jQuery(function() {
  const link = document.getElementsByClassName("service-link");
  window.addEventListener("scroll", function() {
    const section1 = Math.trunc(document.getElementById("a-01").getBoundingClientRect().top + window.pageYOffset);
    const section2 = Math.trunc(document.getElementById("a-02").getBoundingClientRect().top + window.pageYOffset);
    const section3 = Math.trunc(document.getElementById("a-03").getBoundingClientRect().top + window.pageYOffset);
    const section4 = Math.trunc(document.getElementById("a-04").getBoundingClientRect().top + window.pageYOffset);
    // スクロール位置の取得
    const scrollY = window.scrollY || document.documentElement.scrollTop;
    let Height = Math.trunc(jQuery("header").innerHeight() + scrollY);
    if (Height >= section1 && Height < section2) {
      for (let i = 0; i < link.length; i++) {
        // 各要素のinnerHTMLを新しい画像に変更する
        if (link[i].classList.contains("ac")) {
          link[i].classList.remove("ac");
        }
      }
      link[0].classList.add("ac");
    } else if (Height >= section2 && Height < section3) {
      for (let i = 0; i < link.length; i++) {
        // 各要素のinnerHTMLを新しい画像に変更する
        if (link[i].classList.contains("ac")) {
          link[i].classList.remove("ac");
        }
      }
      link[1].classList.add("ac");
    }else if (Height >= section3 && Height < section4) {
      for (let i = 0; i < link.length; i++) {
        // 各要素のinnerHTMLを新しい画像に変更する
        if (link[i].classList.contains("ac")) {
          link[i].classList.remove("ac");
        }
      }
      link[2].classList.add("ac");
    } else if (Height >= section4) {
      for (let i = 0; i < link.length; i++) {
        // 各要素のinnerHTMLを新しい画像に変更する
        if (link[i].classList.contains("ac")) {
          link[i].classList.remove("ac");
        }
      }
      link[3].classList.add("ac");
    }
  });
});

var swiperMain = new Swiper('.slider-main', {
  slidesPerView: 2.5,
  spaceBetween: 0,
  loop: true,
  speed: 1000,
  loopAdditionalSlides: 3,
  loopedSlides: 1,
  grabCursor: true,
  autoplay: { delay: 4000, disableOnInteraction: false },
  observer: true,
  observeParents: true,
  on: {
    init: function() {
      if(location.hash){
        // Swiper が DOM を整えたあとでスクロール
        setTimeout(()=>scrollToHash(location.hash,false), 100);
      }
    }
  }
});

window.addEventListener('load', function(){
  swiperMain.init(); // init:false の場合はここで
});

/* window.onload = function() {
  var swiperMain = new Swiper(".slider-main", {
    slidesPerView: 2.5,
    spaceBetween: "0%",
    loop: true,
    speed: 1000,
    loopAdditionalSlides: 3,
    loopedSlides: 1,
    grabCursor: true,
     autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
    });
}; */
